<template>
  <div style="background: #f9f9f9">
    <div class="soluBanner">
      <div class="bannerCar">
        <el-carousel
          :interval="5000"
          :height="imgHeight + 'px'"
          style="background-color: #fff"
          indicator-position="none"
        >
          <el-carousel-item v-for="(items, index) in imageList" :key="index">
            <img :src="items.url" alt="" style="width: 100%" ref="image" />
            <!--<div class="soluBanBox">
              <h1>基于互联网线上+线下大型砂型铸造解决方案</h1>
              <div class="soluBanText">
                <p>
                  RICH INDUSTRY SOLUTIONS AND CASES COVER ALL FIELDS,AND 3D
                  PRINTING INTELLIGENTLY CREATES THE FUTURE
                </p>
              </div>
            </div>-->
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="solutionDetailTabs">
      <div class="solutionDetailTabBox flex">
        <div
          v-for="(items, index) in solutionTabs"
          :key="index"
          class="detailTabBox"
          @click="getparkMore(index)"
        >
          {{ items.names }}
        </div>
      </div>
    </div>
    <div class="park_dynamic">
      <div class="park_box flex">
        <div class="park_box_img">
          <el-carousel
            indicator-position="outside"
            class="carouseItems"
            arrow="never"
          >
            <el-carousel-item
              v-if="
                videoUrl.endsWith('mp4') ||
                videoUrl.endsWith('avi') ||
                videoUrl.endsWith('mov') ||
                videoUrl.endsWith('wmv')
              "
            >
              <videoPlayer :videoUrl="videoUrl" :videoImgUrl="videoImgUrl" />
            </el-carousel-item>
            <el-carousel-item
              v-if="
                videoUrl.endsWith('jpeg') ||
                videoUrl.endsWith('jpg') ||
                videoUrl.endsWith('png')
              "
            >
              <img :src="videoUrl" alt="" style="width: 100%; height: 100%" />
            </el-carousel-item>
          </el-carousel>
          <div class="bannerText">
            <div style="display:flex;justify-content: space-between;align-items: center;">
              <h4>{{ parkInfo.parkName }}</h4>
              <a v-if="parkInfo.parkName.includes('安徽繁昌春谷')" style="color: #007aff" href="https://utest.gf-yun1.cn/" target="_blank">春谷智慧园区</a>
            </div>
            <p>{{ parkInfo.detail }}</p>
          </div>
        </div>
        <div class="park_box_right">
          <div
            class="park_right_box flex"
            v-for="(items, index) in parkTopList"
            :key="index"
            @click="getDetails(items.uuid)"
          >
            <!-- v-if="index > 3" -->

            <div class="park_right_img">
              <img :src="items.pictureUrl" alt="" />
            </div>
            <div class="park_right_text">
              <p class="park_right_textp">
                {{ items.title }}
              </p>
              <p class="park_right_textM">
                {{ items.summary }}
              </p>
              <div class="park_right_times flex">
                <p>{{ items.createDate.substring(0, 10) }}</p>
                <p>{{ items.createDate.substring(10) }}</p>
                <p class="flex" style="align-items: center">
                  <i class="iconfont">&#xe611;</i>
                  <span>{{ items.pageViews }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 园区VR -->
    <div class="park_vr">
      <p>园区VR</p>
      <div
        class="park_vr_img"
        @click="goToVeiws(parkInfo)"
        v-if="parkInfo.vrImage != ''|| parkInfo.vrUrl != null"
      >
        <img
          :src="parkInfo.vrImage"
          alt=""
        />
        <div class="VrIcons" v-if="parkInfo.vrUrl || (parkInfo.vrList && parkInfo.vrList.length > 0)">
          <i class="el-icon-video-camera"></i>
          <p>园区VR</p>
        </div>
      </div>
      <div class="park_vr_img" v-else>
        <p>该园区未上传VR图</p>
      </div>
    </div>
    <!-- 重点企业 -->
    <div class="park_enterprise" >
		<!-- @showEnterPriseInfo="showEnterPriseInfoFn" -->
      <p class="park_title">重点企业</p>
      <div class="park_swiper">
        <ParkSwiper />
      </div>
    </div>
  </div>
</template>

<script>
import ParkSwiper from "../parkSwiper/parkSwiper";
import {
  getParkDetail,
  getNewsItemList,
  getVrGroupList,
} from "../../utils/interface";
import videoPlayer from "./parkVideo";
import { mapState } from "vuex";

export default {
  name: "parkDynamic",
  components: { ParkSwiper, videoPlayer },
  data() {
    return {
      imgHeight: "",
      imgHeightsetIn: null,
      current: 0,
      pageSize: 4,
      parkId: "", // 园区id
      textarea: "",
      parkSource: "",
      videoUrl: "",
      videoImgUrl: "",
      solutionTabs: [
        {
          names: "园区概况",
        },
        {
          names: "园区动态",
        },
        {
          names: "查看更多 >",
        },
      ],
      solutionTabsIndex: "0",
      parkTopList: [],
      imageList: [],
      parkInfo: {},
      setIn: null, // 定时器
    };
  },
  created() {
    this.parkId = this.$route.params.uuid;
	console.log(this.parkInfo,'初始化时的值')
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
		  clearInterval(this.setIn);
        this.getParkDetail();
        this.getVrGroupList(this.parkId);
        // 园区动态
        this.getNewsItemList();
      }
    }, 500);

  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {
    if (this.imageList.length !== 0) {
      window.addEventListener("resize", () => {
        this.imgHeight = this.$refs.image[0].height;
      });
    }
  },
  methods: {
    imgLoad() {
      this.$nextTick(function () {
        // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
        // this.imgHeight = (document.body.clientWidth * 1) / 4;
        this.imgHeightsetIn = setInterval(() => {
          if (this.imgHeight == 0) {
            this.imgHeight = this.$refs.image[0].height;
            // console.log(5555, this.imgHeight);
          } else {
            clearInterval(this.imgHeightsetIn);
            // console.log(6666, this.imgHeight);
          }
        }, 520);
      });
    },
    // 园区动态
    getNewsItemList() {
      let params = {
        status: "PUBLISH",
        origin: "PARK",
        current: this.current,
        pageSize: this.pageSize,
        programUuid: "",
        parkSource: this.parkId,
      };

      getNewsItemList(params).then((res) => {
        if (res.success) {
          this.parkTopList = res.data;
        }
      });
    },
    getVrGroupList(uuid) {
      getVrGroupList(uuid).then((res) => {
        if (res.success) {
          console.log(res.data);
        }
      });
    },
    getParkDetail() {
      getParkDetail(this.parkId).then((res) => {
        if (res.length !== 0) {
			console.log(res,'vr')
          this.parkInfo = res;
          this.imageList = res.imageList;
          this.videoUrl = res.videoUrl;
          this.videoImgUrl = res.thumbnail;
          this.imgLoad();
        }
      });
    },
    showEnterPriseInfoFn(val) {
      console.log(val);
    },
    getDetails(uuid) {
      // this.$router.push({ name: "parkDetails", params: { uuid: uuid } });
	  let routeData = this.$router.resolve({
	    name: "parkDetails",
	    params: { uuid:uuid},
	  });
	  window.open(routeData.href, "_blank");
    },

    showVrImageList(uuid) {
      // this.$router.push({ name: "veiws", params: { uuid:uuid} });
    },

    getparkMore(i) {
      if (i == 2) {
        // this.$router.push({
        //   name: "parkDynamic",
        //   params: { uuid: this.parkId },
        // });
		let routeData = this.$router.resolve({
		  name: "parkDynamic",
		  params: { uuid:this.parkId},
		});
		window.open(routeData.href, "_blank");
      }
    },
    // goToVeiws(info){

    //   let routeData = this.$router.resolve({
    //       name: "VeiwsUrl",
    //       query: {
    //         url: info.vrUrl
    //       }
    //     });
    //     window.open(routeData.href, "_blank");
    // },
    goToVeiws(info) {
      if(info.vrUrl){
        let routeData = this.$router.resolve({
          name: "VeiwsUrl",
          query: {
            url: info.vrUrl
          }
        });
        window.open(routeData.href, "_blank");
      } else if (
        info.vrImage == null ||
        info.vrImage == "" ||
        info.vrList == null ||
        info.vrList.length == 0
      ) {
        this.$message('该园区未维护园区VR');
        return;
      } else {
        let routeData = this.$router.resolve({
          name: "veiws",
          params: { uuid: info.uuid },
        });
        window.open(routeData.href, "_blank");
        // this.$router.push({ name:'veiws', params:{ uuid:info.uuid }});
      }
    },
  },
};
</script>

<style scoped lang="less">
.blue {
  color: #1181ff;
}
.soluBanner {
  position: relative;
  width: 100%;
  .soluBanBox {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1200px;
    transform: translate(-50%, -50%);
    color: #fff;
    h2 {
      font-size: 38px;
      letter-spacing: 10px;
    }
    .soluBanText {
      margin: 8px 0 60px;
      p:nth-child(1) {
        font-size: 17px;
      }
      p:nth-child(2) {
        font-size: 9px;
      }
    }
    button {
      border: 1px solid #fff;
      border-radius: 30px;
      color: #fff;
      background: none;
      padding: 2px 5px;
    }
  }

  .bannerCar {
    .el-carousel__item h3 {
      color: #475669;
      font-size: 18px;
      opacity: 0.75;
      line-height: 300px;
      margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
      background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n + 1) {
      /*background-color: #d3dce6;*/
    }
    /*/deep/.el-carousel__arrow--left {
      font-size: 18px;
      left: 250px;
      background: #fff9;
      color: #006ecc;
    }
    /deep/.el-carousel__arrow--right {
      font-size: 18px;
      right: 250px;
      background: #fff9;
      color: #006ecc;
    }*/
  }
}
.solutionDetailTabs {
  width: 100%;
  height: 80px;
  background: #fafcff;
  font-size: 19px;
  .solutionDetailTabBox {
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
    line-height: 80px;
    color: #1181ff;
    .detailTabBox {
      text-align: center;
      font-weight: bold;
    }
    .detailTabBox:nth-last-child(1) {
      font-size: 13px;
      cursor: pointer;
      font-weight: normal;
    }
  }
}
//  园区动态
.park_dynamic {
  background: #fafcff;
  padding-bottom: 40px;
  .park_box {
    width: 1200px;
    margin: 0 auto;
  }
  .park_box_img {
    cursor: pointer;
    width: 538px;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
    }
    .carouseItems {
      position: relative;
    }
    .bannerText {
      p {
        font-size: 13px;
        color: #777;
        margin-top: 10px;
        line-height: 21px;
        cursor: default;
        height: 60px;
        // overflow-y: hidden;
        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      // p:hover::-webkit-scrollbar {
      //   overflow-y: scroll;
      //   width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      //   height: 10px;
      // }

      // ::-webkit-scrollbar-thumb {
      //   /*滚动条里面小方块*/
      //   border-radius: 10px;
      //   box-shadow: inset 0 0 5px rgba(205, 205, 205, 0.564);
      //   background: rgba(205, 205, 205, 0.564);
      // }
      // p::-webkit-scrollbar {
      //   display: none;
      // width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      // height: 1px;
      // }
    }

    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 150px;
      margin: 0 20px;
      position: absolute;
      bottom: 15px;

      line-height: 22px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 93%;
      color: black;
      font-size: 15px;
      background: #0000005c;
      border-radius: 0 0 10px 10px;
    }
    .el-carousel__item img {
      // border-radius: 10px;
    }

    .el-carousel__item:nth-child(2n) {
      background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n + 1) {
      /*background-color: #d3dce6;*/
    }
    /deep/.el-carousel__button {
      width: 4px !important;
      height: 4px !important;
      border-radius: 50% !important;
    }
  }
  .park_box_right {
    width: 700px;
    .park_right_box {
      cursor: pointer;
      margin-left: 30px;
      // border-bottom: 1px solid #efefef;
      padding-bottom: 5px;
      margin-bottom: 6px;
      .park_right_img {
        flex-shrink: 0;
        border-radius: 10px;
        background: #efefef;
        width: 151px;
        // height: 100px;
        margin-right: 20px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
      .park_right_text {
        //width: 73%;
        .park_right_textp {
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          word-wrap: break-word;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .park_right_textM {
          // height: 30%;
          font-size: 14px;
          color: #777;
          margin: 12px 0 9px;
          display: -webkit-box;
          overflow: hidden;
          white-space: normal !important;
          text-overflow: ellipsis;
          word-wrap: break-word;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .park_right_times {
          font-size: 13px;
          color: #c7c7c7;
          p {
            margin-right: 25px;
          }
        }
      }
    }
    .park_right_box:nth-last-child(1) {
      border-bottom: none;
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
}
// 园区VR
.park_vr {
  width: 1200px;
  margin: 25px auto;

  p {
    color: #1181ff;
    text-align: center;
    font-size: 19px;
    font-weight: bold;
  }
  .park_vr_img {
    cursor: pointer;
    position: relative;
    width: 1200px;
    height: 450px;
    background: #efefef;
    margin-top: 25px;
    img {
      width: 100%;
      height: 100%;
      // border-radius: 20px;
    }
    p {
      text-align: center;
      line-height: 300px;
    }
    .VrIcons {
      position: absolute;
      top: 18px;
      right: 18px;
      display: flex;
      align-items: center;
      color: #fff;
      background: rgba(0, 0, 0, 0.475);
      padding: 3px 10px;
      border-radius: 30px;
      i {
        margin-right: 5px;
      }
      p {
        font-size: 14px;
        color: #fff;
        line-height: 24px;
        font-weight: normal;

      }
    }
  }
}
// 重点企业
.park_enterprise {
  .park_title {
    color: #1181ff;
    text-align: center;
    padding-bottom: 25px;
    font-size: 19px;
    font-weight: bold;
  }
  .park_enterprise_box {
    background: #fafcff;
    .park_enterprise_box_width {
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      padding: 25px 0;
      .park_enterprise_left {
        width: 500px;
        position: relative;
        .park_enterprise_title {
          margin-bottom: 10px;
        }
        .park_enterprise_mess {
          cursor: default;
          font-size: 13px;
          color: #777;
          line-height: 25px;
          text-indent: 2em;
        }
        .park_enterprise_mess:nth-child(3) {
          margin-top: 20px;
        }
        .park_enterprise_button {
          position: absolute;
          bottom: 0;
          font-size: 13px;
          button {
            align-items: center;
            color: #1181ff;
            border: 1px solid #1181ff;
            background: none;
            padding: 2px 6px;
            border-radius: 5px;
            margin-right: 10px;
            i {
              margin-right: 5px;
            }
          }
        }
      }
      .park_enterprise_img {
        width: 625px;
        height: 350px;
        background: #fff;
        border-radius: 10px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
    }
  }
  .park_swiper {
    background: #fafcff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/park/allPark.vue